import React from 'react';

const HtmlSVG = () => {
  return (
    <svg width="63" height="63" viewBox="0 0 63 63" fill="none" xmlns="http://www.w3.org/2000/svg">
      <ellipse cx="31.8748" cy="31.5" rx="31.125" ry="31.5" fill="#FFE7E0"/>
      <g clipPath="url(#clip0_0_1)">
      <path d="M16.2966 15H48.4529L45.5282 45.9968L32.3395 49.5L19.2259 45.9954L16.2966 15ZM27.0628 29.0156L26.7076 25.1085L42.1104 25.1128L42.4626 21.3437L22.2869 21.3394L23.3557 32.8538H37.3299L36.8307 37.7786L32.3748 38.9344L27.8499 37.77L27.562 34.7369H23.567L24.0723 40.7327L32.3748 42.8171L40.6113 40.7428L41.7506 29.0171H27.0628V29.0156Z" fill="#E34F26"/>
      </g>
      <defs>
      <clipPath id="clip0_0_1">
      <rect width="36.75" height="34.5" fill="white" transform="translate(14 15)"/>
      </clipPath>
      </defs>
    </svg>
  )
}

export default HtmlSVG;